import { Injectable } from '@angular/core';
// declare var $: any;

@Injectable()
export class JqGridService {
    // 设置默认参数：覆盖掉jqGrid的默认参数。
    defaultOptions = {
        pager: 'jqGridPager' + Date.now(),
        altRows: false,
        altclass: 'ng-jq-grid-even',
    }
    $jqGridEle: any;

    constructor() {}
    // 对象深拷贝
    deepCopyObject(source: Object): Object {
        if (typeof source !== 'object') {
            return source;
        }
        const result = Array.isArray(source) ? [] : {};
        const sourceArr = Object.keys(source);
        for (const key of sourceArr) {
            result[key] = typeof source[key] === 'object' ? this.deepCopyObject(source[key]) : source[key];
        }
        return result;
    }

    // 处理用户传入组件的界面参数
    handleInitOptions(interdaceOptions: Object, eventOptions: Object): Object {
        if (interdaceOptions['hidePagerBar']) {
            interdaceOptions['pager'] = undefined;
        }
        return Object.assign(interdaceOptions, eventOptions, this.deepCopyObject(this.defaultOptions));
    }

    // 处理用户传入组件的事件参数
    handleFunctionOptions(functionOptions: Object): void {
        if (!functionOptions) {return; }
        if (functionOptions['toolBarSettings']) {
            const argsArr = []
            functionOptions['toolBarSettings']['edit'] && argsArr.push({
                editCaption: '编辑行',
                recreateForm: true,
                checkOnUpdate : true,
                checkOnSubmit : true,
                closeAfterEdit: true,
                errorTextFormat: function (data) {
                    return 'Error: ' + data.responseText
                }
            });
            functionOptions['toolBarSettings']['add'] && argsArr.push({
                addCaption: '添加行',
                closeAfterAdd: true,
                recreateForm: true,
                errorTextFormat: function (data) {
                    return 'Error: ' + data.responseText
                }
            });
            functionOptions['toolBarSettings']['del'] && argsArr.push({
                delCaption: '删除行',
                errorTextFormat: function (data) {
                    return 'Error: ' + data.responseText
                }
            });
            this.$jqGridEle.navGrid('#' + this.defaultOptions.pager, {
                edit: functionOptions['toolBarSettings']['edit'] || false,
                add: functionOptions['toolBarSettings']['add'] || false,
                del: functionOptions['toolBarSettings']['del'] || false,
                search: functionOptions['toolBarSettings']['search'] || false,
                refresh: functionOptions['toolBarSettings']['refresh'] || false,
                view: functionOptions['toolBarSettings']['view'] || false,
                position: 'left',
                cloneToTop: false
            }, ...argsArr);
        }
        if (functionOptions['showFiltertoolBar']) {
            this.$jqGridEle.jqGrid('filterToolbar');
        }
        if (functionOptions['flozenColums']) {
            this.$jqGridEle.jqGrid('setFrozenColumns');
        }
        if (functionOptions['groupHeaders']) {
            this.$jqGridEle.setGroupHeaders({
                    useColSpanStyle: true,
                    groupHeaders: functionOptions['groupHeaders']
                });
        }
        if (functionOptions['bindKeys']) {
            this.$jqGridEle.jqGrid('bindKeys');
        }
    }

    // data更新-刷新表格
    updateData(newData: Array<any>, pageNum?: number): void {
        this.$jqGridEle && pageNum === undefined && (pageNum = this.$jqGridEle.getGridParam('page'));
        this.$jqGridEle && this.$jqGridEle.jqGrid('clearGridData');
        this.$jqGridEle && this.$jqGridEle.jqGrid('setGridParam', {
            datatype: 'local',
            data : newData,
            page: pageNum || 1
      }).trigger('reloadGrid');
    }

    // 初始化
    init(jqGridEle: Object, jqGridPagerEle: Object, inputData: Array<any>, interdaceOptions: Object, eventOptions: Object, functionOptions: Object): void {
        this.$jqGridEle = $(jqGridEle);
        $(jqGridPagerEle).attr('id', this.defaultOptions.pager);
            interdaceOptions['url'] || (interdaceOptions['data'] = inputData);
            const newInterdaceOptions = this.deepCopyObject(this.handleInitOptions(interdaceOptions, eventOptions));
            this.$jqGridEle.jqGrid(newInterdaceOptions);
            this.handleFunctionOptions(functionOptions);
    }

    // 结束删除
    destroy() {
        this.$jqGridEle = null;
    }
}
